import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/search-icon.svg'
import _imports_1 from '@/assets/toggle-icon.svg'


const _hoisted_1 = {
  key: 0,
  class: "w-full flex px-2 items-center justify-between gap-2 border-b boder-b-[#898790] pb-[5px]"
}
const _hoisted_2 = { class: "w-full flex items-center gap-2" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 1,
  class: "h-[calc(100vh-132px)] px-2 overflow-y-auto flex flex-col gap-[2px]"
}
const _hoisted_5 = { class: "text-primary-text-color text-sm font-medium tracking-[0.01rem]" }
const _hoisted_6 = ["onClick"]

import { useTranslate } from "@/composables/useTranslate";
import { InstallationInput } from "@/types";
import { ref, watch, nextTick } from "vue";

type Props = {
  steps: any;
  selectedInput: InstallationInput | null;
  repeatableGroupIndex?: number;
  isStepsMenuOpen: boolean;
};

type Emits = {
  (event: "onToggle"): void;
  (
    event: "setSelectedInput",
    input: number,
    repeatableGroupIndex?: number
  ): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'FocusModeModalSteps',
  props: {
    steps: {},
    selectedInput: {},
    repeatableGroupIndex: {},
    isStepsMenuOpen: { type: Boolean }
  },
  emits: ["onToggle", "setSelectedInput"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const { t } = useTranslate();

const searchByInputName = ref("");

const inputRefs = ref<Record<number, HTMLElement | any>>({});

watch(
  [props.selectedInput, props.repeatableGroupIndex],
  async ([newInput, _newRepeatableGroupIndex], [_oldInput, _oldIndex]) => {
    await nextTick();
    const el = inputRefs.value[newInput?.id];
    if (el && props.isStepsMenuOpen) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
);

const getParentInputName = (stepId: number, currentInput: any) => {
  let step = props.steps.find((step: any) => step.id === stepId);
  let parentInput = step.inputs.find(
    (input: any) => input.id === currentInput.parentId
  );
  if (!parentInput) {
    return "";
  }

  if (parentInput.type === "repeatable_group") {
    let repeatableGroupDetails = parentInput.repeatableGroupDetails.find(
      (detail: any) => detail.order === currentInput.repeatableGroupIndex + 1
    );
    return repeatableGroupDetails.name;
  }
  return parentInput.name;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["h-[calc(100vh-90px)] bg-[#F9F8F6] rounded-primary-radius py-2 transition-all duration-200 ease-in-out overflow-hidden", {
      'w-[239px]': __props.isStepsMenuOpen,
      'w-0 !p-0 ': !__props.isStepsMenuOpen,
      'opacity-100': __props.isStepsMenuOpen,
      'opacity-0': !__props.isStepsMenuOpen,
    }])
  }, [
    (__props.isStepsMenuOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchByInputName).value = $event)),
              class: "w-full bg-transparent outline-none text-[#898790] text-sm tracking-[0.01rem] font-medium",
              type: "text",
              placeholder: _unref(t)('focus_mode_modal.substeps').value
            }, null, 8, _hoisted_3), [
              [_vModelText, searchByInputName.value]
            ])
          ]),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('onToggle'))),
            class: "flex items-center justify-center"
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("img", {
              class: "max-w-[16px] max-h-[16px] min-w-[16px] min-h-[16px]",
              src: _imports_1,
              alt: "Toggle"
            }, null, -1)
          ]))])
        ]))
      : _createCommentVNode("", true),
    (__props.isStepsMenuOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.steps.filter((step)=> step.inputs.filter((input) =>
        (input.type === 'image' || input.subtype === 'image') && input.value && input.value.length > 0 && input.name.toLowerCase().includes(searchByInputName.value.trim().toLowerCase())).length > 0), (step, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: step.id,
              class: _normalizeClass(index === 0 ? 'mt-2' : 'mt-[10px]')
            }, [
              _createElementVNode("h4", _hoisted_5, _toDisplayString(step.name), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["border-l-2 ml-2 mt-1", __props.selectedInput?.id === step.inputs.find((item) => item.id)?.id ? 'border-l-[#D3D1CD]' : 'border-l-[#E3E1EA]'])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.inputs.filter((input)=> (input.type === 'image' || input.subtype === 'image') && input.value && input.value.length > 0 && input.name.toLowerCase().includes(searchByInputName.value.trim().toLowerCase())), (input) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: input.id,
                    class: _normalizeClass(["relative ml-[6px] rounded-primary-radius px-[6px] py-[2px] cursor-pointer duration-300", `${
              __props.selectedInput?.id === input.id &&
              (__props.repeatableGroupIndex !== null &&
              __props.repeatableGroupIndex !== undefined
                ? input.repeatableGroupIndex === __props.repeatableGroupIndex
                : true)
                ? 'bg-[#DFDEDC]'
                : 'bg-transparent'
            }`]),
                    onClick: ($event: any) => (
              _ctx.$emit('setSelectedInput', input.id, input.repeatableGroupIndex)
            ),
                    ref_for: true,
                    ref: (el) => (inputRefs.value[input.id] = el)
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-sm text-primary-text-color font-normal leading-5", 
                __props.selectedInput?.id === input.id &&
                (__props.repeatableGroupIndex !== null &&
                __props.repeatableGroupIndex !== undefined
                  ? input.repeatableGroupIndex === __props.repeatableGroupIndex
                  : true)
                  ? 'before:absolute before:top-0 before:-left-2 before:h-full before:w-[2px] before:bg-[#70899C]'
                  : ''
              ])
                    }, _toDisplayString(input.parentId ? getParentInputName(step.id, input) + " /" : "") + " " + _toDisplayString(input.name), 3)
                  ], 10, _hoisted_6))
                }), 128))
              ], 2)
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})